import Box, { type BoxProps } from "@mui/material/Box";
import { forwardRef } from "react";

import { mergeSxProps } from "../../lib/mergeSxProps";

export interface ImageProps extends Omit<BoxProps, "component" | "children"> {
  src: string;
  alt: string;
}

/**
 * MUI Box using img component inside.
 */
export const Image = forwardRef((props: ImageProps, ref) => {
  const { sx, width, height, ...boxProps } = props;

  return (
    <Box
      component="img"
      {...boxProps}
      ref={ref}
      sx={mergeSxProps(
        {
          /**
           * Box does not pass `width` and `height` through.
           * Instead, pass it in via `sx`
           */
          width,
          height,
        },
        sx
      )}
    />
  );
});

Image.displayName = "Image";
